export default __webpack_public_path__ + "static/media/monitor.f62d56a1.png";